


import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import LabelService from '@/shared/services/label-service';
import HttpService from '@/shared/services/http-service';

import StudySelectView from '../StudySelectView/StudySelectView.vue';
import StudyInformationView from '../StudyInformationView/StudyInformationView.vue';
import ApplicationFormView from '../ApplicationFormView/ApplicationFormView.vue';
import Loader from '@/shared/components/Loader.vue';
import ErrorMessage from '@/shared/components/ErrorMessages.vue';

import { IConfig } from '../../models/config-viewmodel';

@Component({
    components: {
        StudySelectView,
        StudyInformationView,
        ApplicationFormView,
        Loader,
        ErrorMessage
    },
    computed: {
        ...mapState(['form', 'activeView', 'config', 'loading']),
        ...mapGetters('root', ['label', 'labelHelp'])
    }
})
export default class RegisterWidget extends Vue {
    @Prop() configRaw!: string;

    public config!: IConfig;
    private labelModule = 'SelfServiceVUnetID';
    public form: any;
    private loaderText: string = '';

    mounted() {
        this.setConfig();
    }

    private setConfig() {
        try {
            this.$store.commit('setConfig', this.configRaw);
            this.loaderText = this.config.language === 'nl' ? 'Even geduld - we laden de pagina' : 'Please wait - we are loading the page';
            this.loadData();
        } catch(err) {
            this.$store.commit('root/setErrors', [
                this.config.language === 'nl' ? 
                    'Er gaat iets fout, probeer het later nog een keer' : 
                    'Something went wrong, please try again later'
            ]);
            this.$store.commit('setLoading', false);
        }
    }

    private loadData() {
        Promise.all([
            LabelService.getLabelsByCategory(this.config.language, 'Self Service.Registration', HttpService),
            LabelService.getLabelsByCategory(this.config.language, 'Self Service.VUnetID', HttpService),
        ])
        .then(values => {
            this.$store.commit('root/setLabels', {labels: values[0], type: 'SelfServiceRegistration'});
            this.$store.commit('root/setLabels', {labels: values[1], type: this.labelModule});
            this.$store.commit('setLoading', false);
            this.$store.commit('setActiveView', 'StudySelectView');
        })
        .catch(error => {
            this.$store.commit('root/setErrors', [
                this.config.language === 'nl' ? 
                    'Er gaat iets fout, probeer het later nog een keer' : 
                    'Something went wrong, please try again later'
            ]);
            this.$store.commit('setLoading', false);
        })
    }
}
